import React, { useCallback, useEffect, useState } from "react";
import {Amplify, API, Auth, Cache} from 'aws-amplify';
import { useSearchParams, useNavigate } from "react-router-dom";
import { getUser } from '../graphql/queries';
import { updateUser } from '../graphql/mutations';
import { Signer } from '@aws-amplify/core';

const StripeCheckoutPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const subscriptionType = searchParams.get("subscription");
  const [isProcessingCheckout, setIsProcessingCheckout] = useState(true);
  const [dialogModalOpen, setDialogModalOpen] = useState(false);
  const [dialogModalMessage, setDialogModalMessage] = useState("");

  useEffect(() => {
    const startTrial = async () => {
      try {
        const cognitoUser = await Auth.currentAuthenticatedUser();
        const { attributes } = cognitoUser;
        const payload = cognitoUser.signInUserSession?.idToken?.payload || {};
  
        const email = attributes?.email || payload?.email;
  
        if (!email) {
          throw new Error("Email not available from Cognito user attributes or token payload.");
        }

        const credentials = await Auth.currentCredentials();

        const endpoint = "https://r4pqbt54huoijrxq6manc7r2du0sqoao.lambda-url.us-east-1.on.aws";
        const subscriptionPayload =JSON.stringify({ subscription: subscriptionType, email: email })
        const serviceInfo = {
          service: 'lambda',
          region: 'us-east-1'
        };

        const signedRequest = await Signer.sign(
          {
            url: endpoint,
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            data: subscriptionPayload,
          },
          {
            access_key: credentials.accessKeyId,
            secret_key: credentials.secretAccessKey,
            session_token: credentials.sessionToken,
          },
          serviceInfo
        );
        
        const response = await fetch(signedRequest.url, {
          method: "POST",
          headers: signedRequest.headers,
          body: subscriptionPayload,
        });
 
        const data = await response.json();
        if (!response.ok) {
          alert("Error: " + (data.error || "Could not start trial."));
          setIsProcessingCheckout(false);
          return;
        }

        const customerId = data.customerId;
        const plan = subscriptionType;

        await API.graphql({ query: updateUser, variables: { input: { id: email, stripeId: customerId } } });
        const result = await API.graphql({ query: getUser, variables: { id: email } });

        if (result.data.getUser) {
          result.data.getUser['plan'] = plan;
          Cache.setItem('user', result.data.getUser);
        }

        checkAuthorization();
      } catch (error) {
        alert("An unexpected error occurred: " + error.message);
      }
    };


    async function checkAuthorization() {
      if (Cache.getItem('user')) {
        const refreshToken = Cache.getItem('user')?.refreshToken;
        if (!refreshToken) {
          setIsProcessingCheckout(false);
          setDialogModalMessage("Aitium requires authorization on Amazon Seller Central. Redirecting to authorization page...");
          setDialogModalOpen(true);
          navigate('/authorize');
          return false;
        } else {
          setIsProcessingCheckout(false);
          navigate('/sales-report');
        }
        return true;
      } else {
        setIsProcessingCheckout(false);
      }
      return false;
    }

    if (subscriptionType) {
      startTrial();
    }
  }, [subscriptionType, navigate]);

  return (
    <div style={{ width: "100%", minHeight: "100vh", display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "flex-start", padding: "20px" }}>
        {isProcessingCheckout ? (
        <h2>Starting your free trial...</h2>
        ) : (
        <h2>Redirecting or handling next step...</h2>
        )}

        {/* Optional dialog/modal for manual user feedback */}
        {dialogModalOpen && (
        <div>
        <p>{dialogModalMessage}</p>
        </div>
        )}
    </div>
  );
};

export default StripeCheckoutPage;
